import { last, item, length, isEmpty, singleton, append, exists, filter, truncate, ofArray, empty } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { map } from "../fable_modules/fable-library-js.4.28.0/Array.js";
import { join, split } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { collect, singleton as singleton_1, map as map_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { max, min } from "../fable_modules/fable-library-js.4.28.0/Double.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.28.0/Range.js";

function parseTags(raw) {
    let array_1;
    if (raw.trim() === "") {
        return empty();
    }
    else {
        return ofArray((array_1 = map((s) => s.trim(), split(raw, [","], undefined, 0)), array_1.filter((s_1) => (s_1 !== ""))));
    }
}

function joinTags(tags) {
    return join(", ", tags);
}

/**
 * Tag chip input component with autocomplete dropdown.
 * Renders existing tags as removable chips plus a text input with suggestions.
 */
export function View(viewInputProps) {
    let elems_3;
    const placeholderText = viewInputProps.placeholderText;
    const onChange = viewInputProps.onChange;
    const disabled = viewInputProps.disabled;
    const allTags = viewInputProps.allTags;
    const tags = viewInputProps.tags;
    const currentTags = parseTags(tags);
    const patternInput = reactApi.useState("");
    const setInputText = patternInput[1];
    const inputText = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setShowDropdown = patternInput_1[1];
    const patternInput_2 = reactApi.useState(-1);
    const setHighlightIndex = patternInput_2[1];
    const highlightIndex = patternInput_2[0] | 0;
    let suggestions;
    if (inputText.trim() === "") {
        suggestions = empty();
    }
    else {
        const search = inputText.trim().toLowerCase();
        suggestions = truncate(8, filter((t) => {
            if (t.toLowerCase().indexOf(search) >= 0) {
                return !exists((ct) => (ct.toLowerCase() === t.toLowerCase()), currentTags);
            }
            else {
                return false;
            }
        }, allTags));
    }
    const addTag = (tag) => {
        const trimmed = tag.trim();
        if ((trimmed !== "") && !exists((ct_1) => (ct_1.toLowerCase() === trimmed.toLowerCase()), currentTags)) {
            onChange(joinTags(append(currentTags, singleton(trimmed))));
        }
        setInputText("");
        setShowDropdown(false);
        setHighlightIndex(-1);
    };
    const removeTag = (tag_1) => {
        onChange(joinTags(filter((t_1) => (t_1 !== tag_1), currentTags)));
    };
    return createElement("div", createObj(ofArray([["className", "tag-input-container"], (elems_3 = toList(delay(() => append_1(map_1((tag_2) => {
        let elems;
        return createElement("span", createObj(ofArray([["className", "tag-chip"], ["key", tag_2], (elems = toList(delay(() => append_1(singleton_1(createElement("span", {
            className: "tag-chip-text",
            children: tag_2,
        })), delay(() => (!disabled ? singleton_1(createElement("button", {
            className: "tag-chip-remove",
            type: "button",
            children: "x",
            onClick: (e) => {
                e.stopPropagation();
                removeTag(tag_2);
            },
        })) : singleton_1(defaultOf())))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, currentTags), delay(() => {
        let elems_2;
        return singleton_1(createElement("div", createObj(ofArray([["className", "tag-input-wrapper"], (elems_2 = toList(delay(() => append_1(singleton_1(createElement("input", {
            className: "tag-input-field",
            type: "text",
            placeholder: isEmpty(currentTags) ? placeholderText : "",
            value: inputText,
            disabled: disabled,
            onChange: (ev) => {
                const v = ev.target.value;
                setInputText(v);
                setShowDropdown(v.trim() !== "");
                setHighlightIndex(-1);
            },
            onFocus: (_arg) => {
                if (inputText.trim() !== "") {
                    setShowDropdown(true);
                }
            },
            onBlur: (_arg_1) => {
                setTimeout(() => {
                    setShowDropdown(false);
                }, 200);
            },
            onKeyDown: (e_1) => {
                const key_19 = e_1.key;
                switch (key_19) {
                    case "Enter": {
                        e_1.preventDefault();
                        if ((highlightIndex >= 0) && (highlightIndex < length(suggestions))) {
                            addTag(item(highlightIndex, suggestions));
                        }
                        else if (inputText.trim() !== "") {
                            addTag(inputText);
                        }
                        break;
                    }
                    case "ArrowDown": {
                        e_1.preventDefault();
                        if (length(suggestions) > 0) {
                            setHighlightIndex(min(highlightIndex + 1, length(suggestions) - 1));
                        }
                        break;
                    }
                    case "ArrowUp": {
                        e_1.preventDefault();
                        if (length(suggestions) > 0) {
                            setHighlightIndex(max(highlightIndex - 1, 0));
                        }
                        break;
                    }
                    case "Escape": {
                        setShowDropdown(false);
                        setHighlightIndex(-1);
                        break;
                    }
                    default:
                        if (((key_19 === "Backspace") && (inputText === "")) && !isEmpty(currentTags)) {
                            removeTag(last(currentTags));
                        }
                }
            },
        })), delay(() => {
            let elems_1;
            return (patternInput_1[0] && !isEmpty(suggestions)) ? singleton_1(createElement("div", createObj(ofArray([["className", "tag-autocomplete"], (elems_1 = toList(delay(() => collect((i) => {
                const suggestion = item(i, suggestions);
                return singleton_1(createElement("div", {
                    className: (i === highlightIndex) ? "tag-autocomplete-item tag-autocomplete-item-active" : "tag-autocomplete-item",
                    key: suggestion,
                    onMouseDown: (e_2) => {
                        e_2.preventDefault();
                        addTag(suggestion);
                    },
                    children: suggestion,
                }));
            }, rangeDouble(0, 1, length(suggestions) - 1)))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : singleton_1(defaultOf());
        })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

